<template>
  <div v-if="loadingList">
    <AppSkeletonTable></AppSkeletonTable>
  </div>
  <div v-else>
    <DataTable
      :value="results"
      :scrollable="$isLargeScreen.value"
      responsiveLayout="stack"
    >
      <Column header="Tipo" field="typeId" :sortable="true">
        <template #body="{ data }">
          <CashFlowTypeTag :transaction="data"></CashFlowTypeTag>
        </template>
      </Column>
      <Column header="Categoria" field="categoryId" :sortable="true">
        <template #body="{ data }">
          {{ data?.category?.name || '-' }}
        </template>
      </Column>
      <Column header="Valor" field="value" :sortable="true">
        <template #body="{ data }">
          {{ $toCurrency(data.value) }}
        </template>
      </Column>
      <Column header="Data" field="date" :sortable="true">
        <template #body="{ data }">
          {{ $formatDate(data.date) }}
        </template>
      </Column>
      <Column header="Fazenda" field="farmId" :sortable="true">
        <template #body="{ data }">
          {{ data?.farm?.name || '-' }}
        </template>
      </Column>
      <Column header="Responsável" field="responsibleName" :sortable="true">
      </Column>
    </DataTable>
    <Paginator
      :rows="query.pageSize"
      :totalRecords="pagination.total"
      @page="changeListPage({ page: $event.page + 1 })"
    ></Paginator>
  </div>
</template>

<script>
import useApiList from '../../../lib/useApiList';
import { CashFlowTransactionApi } from '../../../services/api';
import CashFlowTypeTag from './CashFlowTypeTag.vue';

export default {
  name: 'CashFlowTable',
  components: {
    CashFlowTypeTag,
  },
  setup() {
    const apiList = useApiList(CashFlowTransactionApi);
    return { ...apiList };
  },
  async created() {
    await this.fetchList();
  },
};
</script>

<style>
</style>